import { observable, action } from "mobx";
import { PersistentStore } from "./PersistentStore"
import { DocumentFilter } from "./DocumentFilterStore"

class FavouriteDataStoreImpl extends PersistentStore {

	/**
	 * Favourite documents stored separately for accessing from different page
	 */
    constructor() {
        super("favouriteStore");
        this.loadAsync();
    }

    @observable favouriteDocs: string[] = [];

	/**
	 * Add document to favourite list
	 * @param documentId
	* @param language
	 */
    @action public addToFavourite(documentId: string, language: string): void {
        this.favouriteDocs.push(DocumentFilter.createFileVariant(documentId, language));
    }

	/**
	 * Remove document from favourite from list
	 * @param documentId
	 * @param language
	 */
    @action public removeFromFavourite(documentId: string, language: string): void {
        let index = this.favouriteDocs.indexOf(DocumentFilter.createFileVariant(documentId,language));
        if (index > -1) {
            this.favouriteDocs.splice(index, 1);
        }
    }

	/**
	 * Check whether passed document in favourite
	 * @param documentId
	 * @param language
	 */
    @action public isFavourite(documentId: string, language: string): boolean {
        return this.favouriteDocs.some(favourite => favourite === DocumentFilter.createFileVariant(documentId, language));
    }
}

export var FavouriteDataStore = new FavouriteDataStoreImpl();